export type BadgeBaseProps = {
  /**
   * Project locator
   */
  locator: string;
};

export type BadgeInfo = {
  title: string;
  badgeType: string;
  issueType?: IssueType;
  altText: string;
};

export const formatTypes = ['markdown', 'html', 'link'] as const;
export type BadgeFormat = typeof formatTypes[number];

export const badgeTypes = ['licenseShield', 'securityShield', 'small', 'large'] as const;
export type BadgeType = typeof badgeTypes[number];
export type IssueType = 'license' | 'security';
